/* eslint-disable no-secrets/no-secrets */
import React, { useContext, useCallback, useEffect } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import metadata from './UnderwritingComponent.metadata.json5';
import styles from './UnderwritingComponent.module.scss';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function UnderwritingComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('UnderwritingComponent');

    const modelVM = _.get(submissionVM, pathUpdated);

    modelVM.value.isValidationReq = true;


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        doyouoranylivundyoothFie: {
            visible: !_.isUndefined(_.get(submissionVM, 'baseData.baseState_Ext')) && _.get(submissionVM, 'baseData.baseState_Ext.value.code') === 'QC',
            required: !_.isUndefined(_.get(submissionVM, 'baseData.baseState_Ext')) && _.get(submissionVM, 'baseData.baseState_Ext.value.code') === 'QC'
        },
        ifyesexpFie2: {
            visible: !_.isUndefined(_.get(modelVM, 'hasanyinsevecandecforFie.value')) && _.get(modelVM, 'hasanyinsevecandecforFie.value') === true
        },
        ifyesexpFie: {
            visible: !_.isUndefined(_.get(modelVM, 'anyapporhoumembeesarrFie.value')) && _.get(modelVM, 'anyapporhoumembeesarrFie.value') === true
        },
        if3yeexpFie: {
            visible: !_.isUndefined(_.get(modelVM, 'anypenlitcouproorjjudFie.value')) && _.get(modelVM, 'anypenlitcouproorjjudFie.value') === true
        },
        if4yeexpFie: {
            visible: !_.isUndefined(_.get(modelVM, 'aretheanyspecirconknoFie.value')) && _.get(modelVM, 'aretheanyspecirconknoFie.value') === true
        },
        if5yeexpFie: {
            visible: !_.isUndefined(_.get(modelVM, 'anyinstotheknoofthyeaFie.value')) && _.get(modelVM, 'anyinstotheknoofthyeaFie.value') === true
        }
    };

    const resolvers = {
        resolveCallbackMap: {},
        resolveComponentMap: {},
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

UnderwritingComponent.propTypes = wizardProps;
export default withRouter(UnderwritingComponent);
